<template>
  <div id="client-table">
    <div class="overdue-days">
      <ul v-if="lateDays">
        <li @click="() => backOverdueGroup()"><span>&#60;Back</span></li>
        <li><span>| {{ $t('OVERDUE_GROUP') }}:</span></li>

        <li @click="() => swapOverdueGroup('TODAY')"
            :class="{ hightlight: lateDays === 'TODAY' }">
          <span>{{ $t('TODAY') }}</span>
        </li>

        <li @click="() => swapOverdueGroup('1_DAY')"
            :class="{ hightlight: lateDays === '1_DAY' }">
          <span>{{ $t('1_DAY') }}</span>
        </li>

        <li @click="() => swapOverdueGroup('2_3_DAYS')"
            :class="{ hightlight: lateDays === '2_3_DAYS' }">
          <span>{{ $t('2_3_DAYS') }}</span>
        </li>

        <li @click="() => swapOverdueGroup('4_5_DAYS')"
            :class="{ hightlight: lateDays === '4_5_DAYS' }">
          <span>{{ $t('4_5_DAYS') }}</span>
        </li>

        <li @click="() => swapOverdueGroup('OVER_5_DAYS')"
            :class="{ hightlight: lateDays === 'OVER_5_DAYS' }">
          <span>{{ $t('OVER_5_DAYS') }}</span>
        </li>

      </ul>
    </div>
    <div class="d-flex align-items-center justify-content-end">
      <font-awesome-icon class='icon' :icon="faSync" />
      <div class='title'>{{ $t('SWITCH_REPORT') }}:</div>
      <select-input
        class="select"
        v-model="report"
        :items="REPORTS"
      />
    </div>
    <component class='table' :is="component"></component>
  </div>
</template>

<script>
import { computed, ref, getCurrentInstance, watch, onMounted } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import SelectInput from '@/components/SelectInput';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { BIG_CLIENT, OVERDUE_GROUP } from '@/consts';

import BigClient from './BigClient';
import OverdueGroup from '../OverdueGroup';

const { useState, useActions } = createNamespacedHelpers('paymentReminder');

export default {
  name: 'Client-Table',
  components: {
    FontAwesomeIcon,
    SelectInput,
    BigClient,
    OverdueGroup
  },
  setup() {
    const vm = getCurrentInstance();

    const { isCurrentComponent, lateDays } = useState(['isCurrentComponent', 'lateDays']);
    const { setCurrentComponent, setLateDays } = useActions(['setCurrentComponent', 'setLateDays']);

    const REPORTS = [
      {
        text: vm.$i18n.t('BIG_CLIENT'),
        value: BIG_CLIENT,
      },
      {
        text: vm.$i18n.t('OVERDUE_GROUP'),
        value: OVERDUE_GROUP,
      },
    ];

    const report = ref('');
    const days = ref('');

    const component = computed(() => {
      switch (isCurrentComponent.value) {
        case BIG_CLIENT:
          return 'big-client';
        case OVERDUE_GROUP:
          return 'overdue-group';
        default:
          return 'big-client';
      }
    });

    const backOverdueGroup = () => {
      setCurrentComponent(OVERDUE_GROUP);
      setLateDays(days.value);
    };

    const swapOverdueGroup = (group) => {
      setLateDays(group);
    };

    onMounted(() => {
      if (isCurrentComponent.value !== '' && lateDays.value !== '') {
        report.value = REPORTS[1].value;
      } else {
        report.value = REPORTS[0].value;
      }
    });

    watch(report, (newVal) => {
      if (newVal === BIG_CLIENT) {
        setCurrentComponent(BIG_CLIENT);
        setLateDays(days.value);
      } else {
        setCurrentComponent(OVERDUE_GROUP);
        setLateDays(days.value);
      }
    });

    return {
      report,
      REPORTS,
      component,
      faSync,
      lateDays,
      backOverdueGroup,
      swapOverdueGroup
    };
  }
};
</script>

<style lang='scss' scoped>
@import "~@/assets/scss/colors";

#client-table {
  .overdue-days {
    position: absolute;
    font-size: 14px;
    ul {
      padding: 0px;
      li {
        cursor: pointer;
        padding: 5px;
        transition: all 0.5s ease-in-out;
        color: $blueNcs;
        text-decoration: underline;
        display: inline;

        &.hightlight {
          color: $paradisePink;
        }

        &:hover {
          color: $paradisePink;
        }
      }
    }

  }
  .icon {
    color: $alizarinCrimson;
  }

  .title {
    margin-left: 4px;
    font-size: 14px;
  }

  .select {
    margin-left: 8px;
    width: 150px;

    /deep/ .display {
      border: 1px solid $mischka;
      border-radius: 4px;
      box-shadow: 0px 2px 3px #0000004D;
      font-size: 14px;
      color: $blueNcs;
      text-align: center;
      height: 28px;
      padding-right: 13px;
      padding-left: 6px;
      padding-bottom: 0px;
      padding-top: 0px;
    }

    /deep/ svg.drop {
      right: 10px;
    }
  }

  .table {
    margin-top: 20px;
  }
}
</style>
